import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  return (
    <div class="container">
      <nav class="navbar navbar-expand-lg navbar-light ">
        <div class="container-fluid">
          <Link class="navbar-brand" to="/">
            <h1>
              <b>S.</b>
            </h1>
          </Link>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav navbar-style ml-auto">
              <li class="nav-item active">
                <Link style={{ color: 'whitesmoke'}} class="nav-link" aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li class="nav-item">
                <Link style={{ color: 'whitesmoke'}} class="nav-link active" to="/about">
                  About
                </Link>
              </li>
              <li class="nav-item active">
                <Link style={{ color: 'whitesmoke'}} class="nav-link" to="/projects">
                  Projects
                </Link>
              </li>
              <li class="nav-item active">
                <Link style={{ color: 'whitesmoke'}} class="nav-link" to="/blog">
                  Blog
                </Link>
              </li>
              <li class="nav-item active">
                <Link style={{ color: 'whitesmoke'}} class="nav-link" to="/contact">
                  Contact
                </Link>
              </li>
              <li class="nav-item active">
                <a
                  style={{ color: 'whitesmoke' , border: '1px solid white'}}
                  class="nav-link"
                  target="_blank"
                  href="https://drive.google.com/file/d/1iEtY2hIMjYXQPpShbW-JxOrzGWYXJNV_/view?usp=sharing"
                >
                  Resume
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
